<template>
  <div style="padding:10px;background-color: #F5F5F5;min-height: 100%">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <Row>
          <Col span="19">
            <Button type="primary" @click="detail={contentUrl:''};modal1=true">+增加轮播图</Button>
          </Col>
          <Col span="5">
          </Col>
        </Row>
      </div>
    </Card>

    <Card dis-hover="true">
      <Spin fix v-if="loading"></Spin>
      <el-table :data="list" size="small" style="width: 100%" >
        <el-table-column prop="fid" label="上传图片" :show-tooltip-when-overflow="true" width="230">
          <template slot-scope="scope">
            <img :src="'/api/upload/online/'+scope.row.fid" style="width:200px;"/>
          </template>
        </el-table-column>
        <el-table-column prop="contentUrl" label="点击跳转路径" :show-tooltip-when-overflow="true"></el-table-column>
        <el-table-column prop="sort" label="排序，数据越大，越靠前" :show-tooltip-when-overflow="true"></el-table-column>

        <el-table-column prop="msg" label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <a @click="edit(scope.row.id)">编辑</a>
            <cite>|</cite>
            <a @click="remove(scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </Card>

    <Card  :bordered="false" dis-hover style="text-align: center;margin-top:10px">
      <Page :total="count" show-total :page="page" @on-page-size-change="limitChange"  show-elevator @on-change="change"  show-sizer :page-size-opts="[10, 30,50,100]"></Page>
    </Card>

    <Modal
      v-model="modal1"
      title="增加或编辑"
      @on-ok="save"
      @on-cancel="cancel">
      <Form :label-width="80">

        <FormItem label="跳转路径" required>
          <Input v-model="detail.contentUrl"/>
          不跳转：<a @click="detail.contentUrl='/pages/index/index'">/pages/index/index</a>
          <!--跳转在线课：-->
          <!--<a @click="detail.contentUrl='/pages/courseDetailsOl/courseDetailsOl?ProductId='">-->
            <!--/pages/courseDetailsOl/courseDetailsOl?ProductId=<span style="color:red">4134</span>-->
          <!--</a>-->
          <br/>
          跳转公开课：
          <a @click="detail.contentUrl='/pages/courseDetails/courseDetails?ProductId='">
            /pages/courseDetails/courseDetails?ProductId=<span style="color:red">4134</span>
          </a>
          <br/>
          红色的编号对应公开课对应场次ID
        </FormItem>

        <FormItem label="上传图片" required>
          <UploadOne v-model="detail.fid"></UploadOne>
          图片分辨率：690*240 像素，大小在200KB左右
        </FormItem>

        <FormItem label="排序">
          <Input v-model="detail.sort"/>
          数字越大，越靠前
        </FormItem>

      </Form>
    </Modal>

  </div>
</template>

<script>

  import UploadOne from '@/public/upload/UploadOne'
  export default {
    components:{UploadOne},
    data(){
      return{
        baseUrl:'/api/home/banners/',
        list:[],
        page:1,
        count:0,
        limit:10,
        modal1:false,
        detail:{},
        serch:{
          key:''
        },
        loading:false,
      }
    },
    methods:{
      load(){
        let that = this;
        let params = [];
        if(this.serch.key){
          params.push('t.id@=@'+this.serch.key);
        }
        that.loading = true;
        this.$axios.get(this.baseUrl+'findall?page='+this.page+'&limit='+this.limit+'&params='+params).then(function(rs){
          that.list = rs.data.data;
          that.count = rs.data.count;
          that.loading = false;
        });
      },
      limitChange(val){
        this.limit = val;
        this.load();
      },
      change(val){
        this.page = val;
        this.load();
      },
      save(){
        let that = this;
        let data = Object.assign({}, this.detail);
        this.$axios({url:this.baseUrl+'save',method:'post',data:this.$qs.stringify(data)}).then(function(rs){
          that.toast(rs.data);
          if(rs.data.success){
            that.detail = {};
          }
        });
      },
      edit(id){
        let that = this;
        this.$axios.get(this.baseUrl+'getById?id='+id).then(function(rs){
          that.detail = rs.data;
          that.modal1 = true;
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗',
          onOk: () => {
            let that = this;
            this.$axios.get(this.baseUrl+'delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      toast(data){
        if(data.success){
          this.load();
          this.$Message.success(data.msg);
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      //权限判断
      this.load();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/Banners.vue